import React from 'react'
import { useTranslation } from 'react-i18next'
import IconSystemDesign from '~/assets/images/system-design.svg'
import { ASSET_PREFIX } from '~/constants/env'
import { LOCALES } from '~/locales'
import { StyledSystemDesignWrapper } from './styled'

export const SystemDesign: React.FC = () => {
  const { i18n, t } = useTranslation()
  const isZh = i18n.resolvedLanguage === LOCALES.ZH

  const targetLitePaper = !isZh
    ? 'Tokenlon-litepaper_en-us'
    : 'Tokenlon-Litepaper_zh-cn'

  return (
    <StyledSystemDesignWrapper className="system-design-wrapper">
      <div className="system-design-inner">
        <div className="system-design-title">{t('system_design')}</div>
        <div className="system-design-description">
          {t('system_design_description')}
        </div>
        <a
          target="_blank"
          href={`${ASSET_PREFIX}/files/${targetLitePaper}.pdf`}
        >
          <div className="view-drawing">{t('view_system_design_drawing')}</div>
        </a>
      </div>
      <div className="system-design-img-wrapper">
        <img
          className="system-design-img"
          src={IconSystemDesign}
          alt="System Architecture"
        />
      </div>
    </StyledSystemDesignWrapper>
  )
}
